<button type="button" class="bg-primary text-white rounded-2" aria-label="Close" (click)="goBack()" alt="Go back">
    <i class="fa fa-times"></i>
</button>
<!-- <button type="button" class="btn-close text-white" aria-label="Close" (click)="goBack()" alt="Go back"></button> -->
<!-- <button type="button" class="btn btn-primary pull-right mb-3" (click)="goBack()"> Go back</button> -->
